import { useMyPharmacyQuery } from '@/features/yakureki'

// 画面の語のうち、 様式の持ち主 (マイライフ株式会社) に固有のもの。報告書の様式はマイライフの
// 原本の写しなので、 その法人の店舗でだけ名乗り、 他の法人は汎用の語にする (前置きは出さない)。
// 法人は店舗名の接頭辞で見る: 発行ツールは店舗名を「ブランド_店舗」で作る (back の署名
// `output_stamp` も同じ約束で店舗を切り出す)。法人 ID は本番と staging で別の行なので
// bundle に焼けない (users/guide_variant.py と同じ事情)。
interface NutritionBrand {
  // 左ペインの見出し (Kakeru の右)
  versionLabel: string
  // 依頼店舗・署名の前置き。空なら出さない
  referringChain: string
  organization: string
}

const MYLIFE: NutritionBrand = {
  versionLabel: 'オールラボ版',
  referringChain: 'オール薬局',
  organization: 'マイライフ株式会社 オールラボ',
}

const GENERIC: NutritionBrand = {
  versionLabel: '管理栄養士版',
  referringChain: '',
  organization: '',
}

const MYLIFE_STORE_PREFIX = 'オール薬局_'

const nutritionBrandOf = (pharmacyName: string): NutritionBrand =>
  pharmacyName.startsWith(MYLIFE_STORE_PREFIX) ? MYLIFE : GENERIC

// 薬局の取得前は undefined (見出しが汎用 → マイライフと切り替わって見えないよう、 呼び出し側は何も出さない)
export const useNutritionBrand = (): NutritionBrand | undefined => {
  const { data } = useMyPharmacyQuery()
  return data ? nutritionBrandOf(data.name) : undefined
}
